import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        show_auth:{
            show:false,
            from:"",
        },
        show_wait:false,
        show_bottom:false,
        user_info:{},
        user_thumb:{},
    },
    mutations: {
        setShowBottom(state,show_bottom){
            state.show_bottom = show_bottom;
        },
        setShowAuth(state,option){
            state.show_auth = option;
        },
        setShowWait(state,show_wait){
            state.show_wait = show_wait;
        },
        setUserInfo(state,user_info = {}){
            state.user_info = user_info;
        },
        setUserThumb(state,user_thumb){
            state.user_thumb = user_thumb;
        }
    },
    actions: {
    },
    modules: {
    }
})
